import { render, staticRenderFns } from "./UserTable.vue?vue&type=template&id=3e271cab&scoped=true&"
import script from "./UserTable.vue?vue&type=script&lang=ts&"
export * from "./UserTable.vue?vue&type=script&lang=ts&"
import style0 from "./UserTable.vue?vue&type=style&index=0&id=3e271cab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e271cab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
